export function mapCharonParams(params: Array<{ param: string, value: string; }>) {

  let result: any = null;

  if (params) {
    result = {};
    params.forEach(params => {
      result[params.param] = result[params.param]
        ? ensureArrayWithItem(result[params.param], params.value)
        : params.value;
    });
  }

  return result;
}

export function ensureArrayWithItem(items: string | string[], item: unknown): Array<unknown> {
  return Array.isArray(items) ? [...items, item] : [items, item];
}
